export function isEquals<T extends string | number | boolean>(
  expect: T,
  value: unknown
): value is typeof expect {
  return value === expect;
}
